<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">凭证汇总表</span>
			<div class="float-right">
				<Button size="s" icon="fa fa-print" @click="printPage">打印</Button>
				<Button size="s" icon="fa fa-download" @click="exportExcel">导出</Button>
			</div>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
			<div class="float-right">
				<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
			</div>
		</div>
		<div class="h-panel-body" type="flex" :space-x="10">
			<table class="balance" v-if="!showNumPrice" id="printTable">
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td colspan="2">金额合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="4" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<table class="balance" v-else id="printTable">
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td rowspan="2" v-width="100">计量单位</td>
					<td colspan="2">金额合计</td>
					<td colspan="2">数量合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
					<td class="text-center">{{item.unit}}</td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
					<td align="right">{{item.currentDebitAmountNum|numFormat}}</td>
					<td align="right">{{item.currentCreditAmountNum|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="7" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {printTable} from '../../js/common/print';
	import {exportXls} from '../../js/common/export';

	export default {
		name: "SubjectSummary",
		data() {
			return {
				dataList: [],
				accountDate: null,
				showNumPrice: false,
				loading: false
			}
		},
		watch: {
			accountDate() {
				this.loadList();
			},
			showNumPrice() {
				this.loadList();
			}
		},
		computed: {
			companyName() {
				let s = (this.$store && this.$store.state) ? this.$store.state.currentAccountSets : null;
				return s ? (s.name || s.accountSetsName || '') : '';
			},
			periodText() {
				if (!this.accountDate) return '';
				return moment(this.accountDate).format('YYYY年MM期');
			},
			exportHead() {
				return this.showNumPrice
					? ['科目编码', '科目名称', '计量单位', '借方金额', '贷方金额', '借方数量', '贷方数量']
					: ['科目编码', '科目名称', '借方金额', '贷方金额'];
			},
			exportRows() {
				return (this.dataList || []).map(item => this.showNumPrice
					? [item.code, item.name, item.unit || '', Number(item.currentDebitAmount || 0),
						Number(item.currentCreditAmount || 0), Number(item.currentDebitAmountNum || 0), Number(item.currentCreditAmountNum || 0)]
					: [item.code, item.name, Number(item.currentDebitAmount || 0), Number(item.currentCreditAmount || 0)]);
			},
			exportTotal() {
				let d = 0, c = 0;
				(this.dataList || []).forEach(i => {
					d += Number(i.currentDebitAmount || 0);
					c += Number(i.currentCreditAmount || 0);
				});
				return this.showNumPrice ? ['合计', '', '', d, c, '', ''] : ['合计', '', d, c];
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.accountbook.loadSubjectSummary({
					accountDate: this.accountDate,
					showNumPrice: this.showNumPrice
				}).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				})
			},
			printPage() {
				if (!this.exportRows.length) {
					this.$Message('暂无数据可打印');
					return;
				}
				printTable({
					title: '凭证汇总表',
					company: this.companyName,
					period: this.periodText,
					head: this.exportHead,
					rows: this.exportRows,
					align: this.showNumPrice ? ['left', 'left', 'center', 'right', 'right', 'right', 'right'] : ['left', 'left', 'right', 'right'],
					footRow: this.showNumPrice
						? `<tr><td class="t-left" colspan="3">合计</td><td class="t-right">${this.exportTotal[3]}</td><td class="t-right">${this.exportTotal[4]}</td><td colspan="2"></td></tr>`
						: `<tr><td class="t-left" colspan="2">合计</td><td class="t-right">${this.exportTotal[2]}</td><td class="t-right">${this.exportTotal[3]}</td></tr>`,
					sign: [{name: '主管', value: ''}, {name: '记账', value: ''}, {name: '审核', value: ''}, {name: '出纳', value: ''}]
				});
			},
			exportExcel() {
				if (!this.exportRows.length) {
					this.$Message('暂无数据可导出');
					return;
				}
				exportXls({
					name: `凭证汇总表_${this.periodText}`,
					sheets: [{
						name: '凭证汇总表',
						head: this.exportHead,
						rows: this.exportRows,
						widths: this.showNumPrice ? [110, 220, 90, 120, 120, 110, 110] : [110, 220, 130, 130],
						types: this.showNumPrice ? ['s', 's', 's', 'n', 'n', 'n', 'n'] : ['s', 's', 'n', 'n'],
						totalRow: this.exportTotal
					}]
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>